(function () {
  'use strict';

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn) {
    if (conn.saveData) return;
    if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return;
  }

  var ORIGIN = location.origin;
  var prefetched = new Set();
  var prerendered = new Set();
  var viewportQueue = [];
  var inflight = 0;
  var MAX_PARALLEL = 4;
  var HOVER_DELAY_MS = 80;
  var PRERENDER_LIMIT = 3;
  var VIEWPORT_ROOTMARGIN = '300px';
  var IMAGE_ROOTMARGIN = '400px';
  var supportsPrerender = typeof HTMLScriptElement !== 'undefined' && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
  var ric = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };

  function isEligible(a) {
    if (!a || a.tagName !== 'A') return false;
    if (a.hasAttribute('data-no-prefetch')) return false;
    if (a.target === '_blank') return false;
    var href = a.href;
    if (!href) return false;
    if (href.indexOf(ORIGIN) !== 0) return false;
    if (href.indexOf('/cart') !== -1) return false;
    if (href.indexOf('/checkout') !== -1) return false;
    if (href.indexOf('/account/logout') !== -1) return false;
    if (href.indexOf('#') === 0) return false;
    if (a.protocol && a.protocol.indexOf('http') !== 0) return false;
    if (prefetched.has(href)) return false;
    return true;
  }

  function doPrefetch(href) {
    if (prefetched.has(href)) return;
    prefetched.add(href);
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = href;
    document.head.appendChild(l);
  }

  function tryPrerender(href) {
    if (!supportsPrerender) return;
    if (prerendered.has(href)) return;
    if (prerendered.size >= PRERENDER_LIMIT) return;
    prerendered.add(href);
    var s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify({
      prerender: [{ source: 'list', urls: [href], eagerness: 'moderate' }]
    });
    document.head.appendChild(s);
  }

  var hoverTimers = new WeakMap();

  function onIntent(e) {
    var a = e.target.closest && e.target.closest('a');
    if (!isEligible(a)) return;
    var href = a.href;
    if (e.type === 'mouseenter') {
      var t = setTimeout(function () { tryPrerender(href); }, HOVER_DELAY_MS);
      hoverTimers.set(a, t);
      doPrefetch(href);
    } else {
      doPrefetch(href);
    }
  }

  function onIntentEnd(e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var t = hoverTimers.get(a);
    if (t) { clearTimeout(t); hoverTimers.delete(a); }
  }

  document.addEventListener('mouseenter', onIntent, true);
  document.addEventListener('mouseleave', onIntentEnd, true);
  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });

  function drainQueue() {
    while (inflight < MAX_PARALLEL && viewportQueue.length) {
      var href = viewportQueue.shift();
      inflight++;
      ric(function (h) {
        return function () {
          doPrefetch(h);
          inflight--;
          if (viewportQueue.length) drainQueue();
        };
      }(href));
    }
  }

  var linkObserver = null;
  if ('IntersectionObserver' in window) {
    linkObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var a = entry.target;
        linkObserver.unobserve(a);
        if (!isEligible(a)) return;
        viewportQueue.push(a.href);
        drainQueue();
      });
    }, { rootMargin: VIEWPORT_ROOTMARGIN });
  }

  function observeLinks(root) {
    if (!linkObserver) return;
    var anchors = (root || document).querySelectorAll('a[href]');
    anchors.forEach(function (a) {
      if (isEligible(a)) linkObserver.observe(a);
    });
  }

  var imageObserver = null;
  if ('IntersectionObserver' in window) {
    imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var img = entry.target;
        imageObserver.unobserve(img);
        if (img.loading === 'lazy') img.loading = 'eager';
        img.decoding = 'async';
      });
    }, { rootMargin: IMAGE_ROOTMARGIN });
  }

  function observeImages(root) {
    if (!imageObserver) return;
    var imgs = (root || document).querySelectorAll('img[loading="lazy"]');
    imgs.forEach(function (img) { imageObserver.observe(img); });
  }

  function init() {
    observeLinks(document);
    observeImages(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          observeLinks(n);
          observeImages(n);
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    observeLinks(e.target);
    observeImages(e.target);
  });
})();
